import { createContext } from 'react';

const dogsContext = createContext();

export default dogsContext;
